import * as React from 'react'
import { Box, chakra, Flex, Heading, Tab, Tabs, TabList, TabPanels, Icon, TabPanel, useColorModeValue } from '@chakra-ui/react'
import { FiBriefcase, FiTool } from 'react-icons/fi'
import ProjectOwners from 'src/marketing/projectOwners'
import Builders from 'src/marketing/builders'
import NextImage from 'src/common/NextImage'
import { useRouter } from 'next/router'
import { useAccent3, useForeground } from 'src/modeAwareColors'
import { H2 } from 'src/typography/typography'

const Emphasis = ({ children }) => {
  const fg = useForeground()
  return (
    <chakra.span color={fg}>
      {children}
    </chakra.span>
  )
}

const HeroIllustration = () => <NextImage
  src='/images/projectlink-engineer.svg'
  dimensions={[420, 306]}
/>

function insertUrlParams(params: { [key: string]: string }) {
  if (!window.location) return null
  if (!history.pushState) return null

  const searchParams = new URLSearchParams(window.location.search)
  Object.keys(params).forEach(key => {
    searchParams.set(key, params[key])
  })

  // const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + searchParams.toString();
  window.history.pushState(null, '', `?${searchParams.toString()}`)
}

const HowItWorks = () => {
  const a3 = useAccent3()
  const tabPanelsBg = useColorModeValue('primary.accent1', 'dark.background')
  const firstRender = React.useRef(true)
  const [index, setActiveTab] = React.useState(0)
  const { query } = useRouter()

  const onTabChange = activeIndex => {
    setActiveTab(activeIndex)
    insertUrlParams({ tab: activeIndex === 1 ? 'owners' : 'builders' })
  }

  React.useEffect(() => {
    if (firstRender.current && query.tab) {
      const defaultIndex = query.tab == 'builders' ? 0 : 1
      setActiveTab(defaultIndex)
      firstRender.current = false
    }
  }, [query?.tab])

  return (
    <>
      <Flex
        align='center'
        layerStyle='appContainer'
        py={28}
      >
        <HeroIllustration />
        <Box mr='auto'>
          <Heading
            textStyle='eyebrow'
            color='successAlt.default'
          >
            How it works
          </Heading>
          <H2
            color={a3}
            maxW='450px'
          >
            Projectlink helps <Emphasis>find</Emphasis>, <Emphasis>connect</Emphasis>,
              and <Emphasis>work</Emphasis> with companies in your industry.
          </H2>
        </Box>
      </Flex>
      <Tabs
        variant='enclosed'
        onChange={onTabChange}
        index={index}
      >
        <TabList>
          <Flex
            width='container.lg'
            px={4}
            marginX='auto'
          >
            <Tab>
              <Icon color={a3} as={() => <FiTool />} />
          &nbsp;Builders and suppliers
            </Tab>
            <Tab>
              <Icon color={a3} as={() => <FiBriefcase />} />
          &nbsp;Project owners
            </Tab>
          </Flex>
        </TabList>
        <TabPanels bg={tabPanelsBg}>
          <TabPanel layerStyle='tabPanel'>
            <Builders />
          </TabPanel>
          <TabPanel layerStyle='tabPanel'>
            <ProjectOwners />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </>
  )
}

export default HowItWorks
